var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$session.exists())?_c('AppBar'):_vm._e(),_c('v-main',[_c('router-view'),(_vm.$session.exists())?_c('Dialog'):_vm._e()],1),_c('Footer',{attrs:{"session-exist":_vm.sessionExist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }